import { getUserAgent } from './get-user-agent';
/**
 * 腾讯会议App
 */
export function isWeMeetApp(ua) {
    return /app\/tencent_wemeet/i.test(getUserAgent(ua));
}
